var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.7818mm",
    height: "6.932mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 677.45 435.56",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465005148064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    y: 421.6,
    width: 677.45,
    height: 13.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M677.45 204.81l-173.73 0 0 -204.81 13.96 0 0 190.85 159.77 0 0 13.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M173.56 204.81l-173.56 0 0 -13.96 159.6 0 0 -190.85 13.97 0 0 204.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 211.3,
    y: 91.93,
    width: 258.85,
    height: 13.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M430.41 149.62l-9.81 -9.81 40.89 -40.9 -40.89 -40.89 9.81 -9.81 50.87 50.71 -50.87 50.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M252.19 149.62l-50.7 -50.71 50.7 -50.71 9.98 9.81 -40.9 40.89 40.9 40.9 -9.98 9.81z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc18);
export default __webpack_public_path__ + "static/media/ic_1_8.dbd3703b92f7448082eb60f487a53499.svg";
export { ForwardRef as ReactComponent };